import { z } from "zod"
import { AttachmentSchema } from "../../messages/attachments"
import { AMPHORA_LOGISTICS_TEMPLATE_LOCALES } from "./communicationsConfig"

export const UpsertAmphoraIntegration = z.object({
  accessId: z.string(),
})

const logisticsLangSchema = z.enum(
  AMPHORA_LOGISTICS_TEMPLATE_LOCALES as unknown as [string, ...string[]],
)

export const UpdateAmphoraCommunicationsSchema = z.object({
  useWhatsapp: z.boolean().optional(),
  useEmail: z.boolean().optional(),
  /** Required on first enable of WhatsApp logistics comms (when no logistics WhatsApp campaign exists). */
  templateLanguages: z.array(logisticsLangSchema).max(25).optional(),
})
export type UpdateAmphoraCommunications = z.infer<typeof UpdateAmphoraCommunicationsSchema>

export const GetAmphoraOrderInfoSchema = z.object({
  orderId: z.string(),
  email: z.string().optional(),
  companyClientExternalId: z.string().trim().min(1).optional(),
})

export const AmphoraPostedViaPermutAssistant = "permut"

export const AmphoraSideEnum = {
  Customer: "customer",
  Client: "client",
  Amphora: "amphora",
}

export const AmphoraDestinationEnum = {
  Permut: "permut",
  PermutAmphora: "permut_amphora",
} as const

export type AmphoraSide = (typeof AmphoraSideEnum)[keyof typeof AmphoraSideEnum]
export type AmphoraDestination =
  (typeof AmphoraDestinationEnum)[keyof typeof AmphoraDestinationEnum]

export const AmphoraMessageWebhookSchema = z.object({
  source: z.string().optional(),
  ticket_add_message: z.object({
    id: z.string().min(1),
    message: z.object({
      date: z.string().optional(),
      message: z.string().nullable(),
      attached_files: z.array(AttachmentSchema).default([]),
      agent: z.string().nullish(),
      user: z.string().nullish(),
      source: z.string().nullish(),
      posted_via: z.string().nullish(),
      side: z.enum(AmphoraSideEnum).nullish(),
    }),
  }),
})

export const AmphoraStatusWebhookSchema = z.object({
  ticket_statuses: z.array(
    z.object({
      id: z.string().min(1),
      status: z.enum(["open", "solved", "closed"]),
    }),
  ),
})

export const AmphoraCompanyWebhookSchema = z.object({
  destination: z.enum([AmphoraDestinationEnum.Permut, AmphoraDestinationEnum.PermutAmphora]),
  companyClient: z.object({
    externalId: z.string().min(1),
    name: z.string().min(1),
  }),
})
